module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_27.8fc6e11c.png";